/**
 * Bootstrap 5 global + small helpers for legacy app scripts.
 * No jQuery plugin shims — call sites use these helpers or window.bootstrap directly.
 */
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

function resolveElements(target) {
    if (!target) {
        return Array.from(document.querySelectorAll('.modal.show'));
    }
    if (typeof target === 'string') {
        return Array.from(document.querySelectorAll(target));
    }
    if (target instanceof Element) {
        return [target];
    }
    if (target && target.jquery) {
        return target.toArray();
    }
    if (typeof target.length === 'number') {
        return Array.from(target);
    }
    return [];
}

export function casaModalShow(target, options) {
    resolveElements(target).forEach(function (el) {
        bootstrap.Modal.getOrCreateInstance(el, options || {}).show();
    });
}

export function casaModalHide(target) {
    resolveElements(target).forEach(function (el) {
        const instance = bootstrap.Modal.getInstance(el);
        if (instance) {
            instance.hide();
        }
    });
}

window.casaModalShow = casaModalShow;
window.casaModalHide = casaModalHide;
